/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { type Capability, capabilities } from '../../constants/capabilities';
import type { EditorPlugins } from '../../types/EditorPlugins';
import type { PluginParsed } from '../../components/PluginSelection/types';
import { findConflictingPlugins } from '../findConflictingPlugins/findConflictingPlugins';

const allFeatures = ( capabilities as ReadonlyArray<Capability> ).flatMap( capability => capability.features );

export function findConflictingFeatures( featurePlugins: Array<PluginParsed>, editorPlugins: EditorPlugins ): Array<string> {
	const conflictingPlugins = findConflictingPlugins( editorPlugins, featurePlugins.map( plugin => plugin.className ) );

	return allFeatures
		.filter( feature => feature.plugins.some( plugin => conflictingPlugins.includes( plugin ) ) )
		.map( feature => feature.name );
}
